import { render } from "./RoomPanel.vue?vue&type=template&id=c5282e04"
import script from "@/assets/js/RoomPanel.js?vue&type=script&lang=js"
export * from "@/assets/js/RoomPanel.js?vue&type=script&lang=js"

import "./RoomPanel.vue?vue&type=style&index=0&id=c5282e04&lang=css"

import exportComponent from "/tmp/workdir/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__